import { MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import { Header, Header2 } from '@app/components/general/header'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import { FeaturesList } from '@app/components/stateless/marketing/features'
import { Address } from '@app/components/general/mailto'
import {
  SUPPORT_EMAIL,
  SALES_EMAIL,
  FILTERED_MARKETING,
} from '@app/configs/app-config'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/web-accessibility-services',
    }),
  }
}

function WebAccessibilityServices() {
  const { t, lang } = useTranslation('web-accessibility-services')

  return (
    <MarketingDrawer>
      <SectionContainer container block>
        <div className='pb-8'>
          <Header>{t('header')}</Header>
          <Paragraph className='text-lg'>{t('header-subtitle')}</Paragraph>
          <div className='pt-6'>
            <Address
              email={
                FILTERED_MARKETING
                  ? SUPPORT_EMAIL || SALES_EMAIL
                  : SALES_EMAIL || SUPPORT_EMAIL
              }
              className={
                'capitalize font-semibold rounded-3xl no-underline text-lg text-white dark:text-black dark:border-gray-700 px-6 py-3 bg-black dark:bg-white hover:bg-blue-700 hover:text-white dark:hover:bg-blue-800 dark:hover:text-white'
              }
              subject='Web Accessibility Services'
            >
              {t('contact')}
            </Address>
          </div>
        </div>
        <div className='text-center bg-gray-100 dark:bg-gray-900 p-4 rounded'>
          <Header2>{t('intro')}</Header2>
          <Paragraph className='text-lg'>{t('intro-details')}</Paragraph>
        </div>
      </SectionContainer>
      <FeaturesList t={t} lang={lang} all />
    </MarketingDrawer>
  )
}

export default metaSetter(
  { WebAccessibilityServices },
  {
    translation: 'web-accessibility-services',
  }
)
